import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useChatFeedback } from '../../ChatFeedbackContext';
import { deliverableImportFeedback } from './card';
import { workstreamLabel } from './shared';
/**
 * WORKSTREAM_INTRO body, scoped to `payload.workstreamKey`. The progress line
 * reads `reviewed` / `total_to_review` straight from the workstream's
 * WorkstreamSummary, so a reload mid-review shows the real server count
 * rather than resetting to 0.
 */ export function WorkstreamIntroCard({ payload, review }) {
    const [begun, setBegun] = useState(false);
    const sendFeedback = useChatFeedback();
    const ws = review.workstreams.find((w)=>w.key === payload.workstreamKey);
    if (!ws) {
        return /*#__PURE__*/ _jsx("div", {
            className: "mt-2 text-sm text-gray-500",
            children: "This workstream is no longer part of the staged import."
        });
    }
    const label = workstreamLabel(ws);
    const handleBegin = ()=>{
        setBegun(true);
        sendFeedback(deliverableImportFeedback({
            event: 'navigate',
            changeSetId: payload.changeSetId,
            workstreamKey: payload.workstreamKey,
            text: `Program Lead began reviewing workstream "${label}".`
        }));
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-2 space-y-2 text-sm text-gray-700",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "font-medium text-gray-900",
                children: label
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "text-xs text-gray-600",
                children: [
                    ws.workbookRowCount,
                    " row",
                    ws.workbookRowCount === 1 ? '' : 's',
                    " found — ",
                    ws.proposedCreates,
                    ' ',
                    "create",
                    ws.proposedCreates === 1 ? '' : 's',
                    ", ",
                    ws.proposedUpdates,
                    " update",
                    ws.proposedUpdates === 1 ? '' : 's',
                    ", ",
                    ws.alreadyMatches,
                    " already match",
                    ws.alreadyMatches === 1 ? 'es' : '',
                    ", ",
                    ws.needsClarification,
                    " need",
                    ws.needsClarification === 1 ? 's' : '',
                    " clarification."
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "text-xs text-gray-600",
                children: [
                    "We'll review ",
                    ws.totalToReview,
                    " proposed change",
                    ws.totalToReview === 1 ? '' : 's',
                    "."
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                "data-testid": Testids.deliverableImport.progress,
                className: "text-xs font-medium text-gray-700",
                children: [
                    "Progress: ",
                    ws.reviewed,
                    " of ",
                    ws.totalToReview,
                    " reviewed"
                ]
            }),
            begun ? /*#__PURE__*/ _jsxs("div", {
                className: "text-xs font-medium text-green-700",
                children: [
                    'Reviewing "',
                    label,
                    '"…'
                ]
            }) : /*#__PURE__*/ _jsx("button", {
                type: "button",
                "data-testid": Testids.deliverableImport.beginReview,
                onClick: handleBegin,
                className: "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors",
                children: "Begin Review"
            })
        ]
    });
}
